import React from 'react';
import MainSiteStack from './routes/mainSiteStack';
import firebaseApi from './modules/firebaseApi';
export default function App() {
  firebaseApi.init();
  return (
      <MainSiteStack />
  )
}